module.exports = new __parcel__URL__("../logoEW.e13d3a0a.svg").toString();